<script setup lang="ts">
const { data: articles } = await useBlogList()
const latestPost = computed(() => articles.value?.[0] ?? null)
const recentArticles = computed(() => articles.value?.slice(1) ?? [])

const { data: rawProducts } = await useAsyncData('shop-products', () =>
  $fetch('/api/products'),
)
const shopProducts = computed(() =>
  (rawProducts.value ?? []).map((p: any) => ({
    title: p.name,
    price: p.price,
    images: p.images,
    category: p.category,
    tags: p.tags,
    slug: `/shop/${p.handle}`,
  })),
)
</script>

<template>
  <div>
    <!-- HERO -->
    <AppHeroSection layout="Centered" />

    <!-- FEATURED STORY -->
    <AppFeaturedStory
      v-if="latestPost"
      :image="latestPost.image"
      :category="latestPost.category"
      :title="latestPost.title"
      :excerpt="latestPost.excerpt"
      :slug="`/journal/${latestPost.handle}`"
    />

    <!-- RECENT STORIES -->
    <AppRecentStories :articles="recentArticles" />

    <!-- FROM THE GOODS -->
    <AppShopSection :products="shopProducts" />

    <!-- QUOTE BANNER -->
    <section
      class="bg-cta flex flex-col gap-3 md:gap-4 h-72 items-center justify-center px-4 md:px-20 w-full text-center text-dark"
    >
      <div class="font-serif font-normal text-xl md:text-3xl leading-[38px]">
        <p class="mb-0 text-primary">"Beauty lives in the unhurried —</p>
        <p class="text-primary">in water, land, and things made with care."</p>
      </div>
      <p class="font-label font-light text-xs leading-4 tracking-wider">
        — WET WATER
      </p>
    </section>
  </div>
</template>
